import "./Footer.css";

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.36 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.11 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16z"/>
  </svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const NAV_LINKS = [
  { label: "Решения",  id: "solutions" },
  { label: "СРО",      id: "sro"       },
  { label: "Проекты",  id: "gallery"   },
  { label: "FAQ",      id: "faq"       },
  { label: "Контакты", id: "contact"   },
];

const SERVICES = [
  "СКС и сети связи",
  "СОТ и видеонаблюдение",
  "СКУД",
  "Серверные и телеком",
  "Пусконаладка",
  "Техобслуживание",
];

export default function Footer() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="footer__inner">

        {/* Сетка колонок */}
        <div className="footer__grid">

          {/* Колонка 1 — Логотип + описание */}
          <div className="footer__col">
            <div className="footer__logo">
              <span className="footer__logo-its">ITS</span>
              <span className="footer__logo-divider" />
              <span className="footer__logo-name">Айти Системы</span>
            </div>
            <p className="footer__desc">
              Строительство сетей связи, СКС, СОТ, СКУД, серверные,
              телекоммуникационная инфраструктура и сервис для бизнеса
              и промышленности Екатеринбурга и УрФО.
            </p>
          </div>

          {/* Колонка 2 — Навигация */}
          <div className="footer__col">
            <h4 className="footer__col-title">Навигация</h4>
            <ul className="footer__list">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="footer__link"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Колонка 3 — Услуги */}
          <div className="footer__col">
            <h4 className="footer__col-title">Услуги</h4>
            <ul className="footer__list">
              {SERVICES.map((service) => (
                <li key={service} className="footer__list-item">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Колонка 4 — Контакты */}
          <div className="footer__col">
            <h4 className="footer__col-title">Контакты</h4>
            <ul className="footer__contacts">
              <li>
                <a href="tel:+78003002910" className="footer__contact-link">
                  <PhoneIcon />
                  <span>8-800-300-29-10</span>
                </a>
              </li>
              <li>
                <a href="mailto:sales@itsystem.ru" className="footer__contact-link">
                  <MailIcon />
                  <span>sales@itsystem.ru</span>
                </a>
              </li>
              <li>
                <div className="footer__contact-item">
                  <MapPinIcon />
                  <span>г. Екатеринбург, работаем по УрФО</span>
                </div>
              </li>
            </ul>
          </div>

        </div>

        {/* Нижняя строка */}
        <div className="footer__bottom">
          <p className="footer__copyright">
            © 2026 ООО «АЙТИ СИСТЕМЫ». Все права защищены.
          </p>
          <div className="footer__bottom-links">
            <a href="#" className="footer__bottom-link">
              Политика конфиденциальности
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}